import styled from "styled-components";

import { StyledFooter as PantheonFooter } from "@minerva-analytics/pantheon";

const StyledFooter = styled(PantheonFooter)``;

export { StyledFooter };
